(function () {
function $e249001961250b97$var$createStateCollectionBanner(el) {
    const form = el.querySelector("form");
    const collectionFilter = document.querySelector("#main-collection-filters");
    const targetForm = collectionFilter.querySelector("form");
    const filterOptions = Array.from(targetForm.querySelectorAll(`.facets__list input[type="checkbox"]`)).filter((i)=>!i.id.includes("-no-js"));
    if (filterOptions.length < 2) form.classList.add("d-none");
    form.addEventListener("submit", (e)=>{
        e.preventDefault();
        const fd = new FormData(form);
        const sel = fd.get("profession");
        const checkbox = targetForm.querySelector(`input[type="checkbox"][value="${sel}"]`);
        checkbox?.click();
        window.scroll({
            top: collectionFilter.offsetTop - 128,
            behavior: "smooth"
        });
    });
}
// class StateCollectionBanner {
// 	constructor(el) {
// 		this.el = el;
// 		this.form = this.el.querySelector("form");
// 		const collectionFilter = document.querySelector(
// 			"#main-collection-filters"
// 		);
// 		const targetForm = collectionFilter.querySelector("form");
// 		const filterOptions = Array.from(
// 			targetForm.querySelectorAll(`.facets__list input[type="checkbox"]`)
// 		).filter((i) => !i.id.includes("-no-js"));
// 		if (filterOptions.length < 2) {
// 			this.form.classList.add("d-none");
// 		}
// 		this.form.addEventListener("submit", (e) => {
// 			e.preventDefault();
// 			const fd = new FormData(this.form);
// 			const sel = fd.get("profession");
// 			const checkbox = targetForm.querySelector(
// 				`input[type="checkbox"][value="${sel}"]`
// 			);
// 			checkbox?.click();
// 			window.scroll({
// 				top: collectionFilter.offsetTop - 128,
// 				behavior: "smooth",
// 			});
// 		});
// 	}
// }
window.addEventListener("DOMContentLoaded", ()=>{
    const bannerEl = document.querySelector("#state-collection-banner");
    if (bannerEl) $e249001961250b97$var$createStateCollectionBanner(bannerEl);
});

})();
//# sourceMappingURL=stateCollectionBanner.js.map
